import React from 'react';
import s from './s.modules.less';
import Frame from './frame.png';

enum EStatus {
    LIVE = 'Live',
    COMING_SOON = 'Coming soon',
    PLANNED = 'Planned',
}

const Benefits = () => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>Why choose ScriptSure</h2>
            <img src={Frame} alt="text visits" />

        </div>
    );
};

export default Benefits;
